import type { TSeat } from '@core/types';

/** 吃碰槓圖示播放期間暫存該家的下一個出牌決策，圖示完成後才交還 scene。 */
export class CMeldTurnGate<TAction> {
  private readonly activeSeats = new Set<TSeat>();
  private readonly pendingActions = new Map<TSeat, TAction>();

  begin(seat: TSeat): void {
    this.activeSeats.add(seat);
    this.pendingActions.delete(seat);
  }

  hold(seat: TSeat, action: TAction): boolean {
    if (!this.activeSeats.has(seat)) return false;
    this.pendingActions.set(seat, action);
    return true;
  }

  complete(seat: TSeat): TAction | null {
    this.activeSeats.delete(seat);
    const action = this.pendingActions.get(seat) ?? null;
    this.pendingActions.delete(seat);
    return action;
  }

  isWaiting(): boolean {
    return this.activeSeats.size > 0;
  }

  cancel(): void {
    this.activeSeats.clear();
    this.pendingActions.clear();
  }
}
